export default {
    namespaced: true,

    state: {
        filters: [],
        selectedFilters: {},
        selectedFiltersCount: {},
        searchQuery: '',
        dates: {
            start: null,
            end: null,
        },
        clearedFilters: false,
    },

    getters: {
        getFilters(state) {
            return state.filters.sort((a, b) => (a.type > b.type) ? 1 : ((b.type > a.type) ? -1 : 0));
        },
        getSelectedFilters(state) {
            return state.selectedFilters;
        },
        areFiltersReset(state) {
            return state.clearedFilters;
        },
        getSelectedFiltersCount(state) {
            return state.selectedFiltersCount;
        },
        getSearchQuery(state) {
            return state.searchQuery;
        },
        getStartDate(state) {
            return state.dates.start;
        },
        getEndDate(state) {
            return state.dates.end;
        },
        getFilter(state) {
            return {
                searchQuery: state.searchQuery,
                filters: state.selectedFilters,
                dates: state.dates,
            };
        },
    },

    actions: {
        updateSearchQuery(context, query) {
            context.commit('setSearchQuery', query);
        },
        updateDates(context, query) {
            context.commit('setDates', query);
        },
        addToFilters(context, filter) {
            context.commit('setFilter', filter);
        },
        toggleFilter(context, filter) {
            if (typeof context.state.selectedFilters[filter.type] === 'undefined') {
                context.commit('setSelectedFilterArray', filter.type)
            }

            if (context.state.selectedFilters[filter.type].indexOf(filter.id) > -1) {
                context.commit('removeFilter', filter);
            } else {
                context.commit('applyFilter', filter);
            }
        },
        clearFilters(context) {
            context.commit('clearFilters');
        },
        resetFilters(context) {
            context.commit('resetFilters');
        },
        clearEverything(context) {
            context.commit('clearFilters');
            context.commit('setSearchQuery', '');
            context.commit('setDates', {key: 'start', value: null});
            context.commit('setDates', {key: 'end', value: null});
        },
        setPredefinedFilters(context, filters) {
            return new Promise((resolve, reject) => {
                for (let i = 0, len = filters.length; i < len; i++) {
                    let parts = filters[i].split('=', 2);

                    let ignoreQueryParams = [
                        'page',
                        'q',
                        'items',
                        'sortDesc',
                        'sortBy',
                        'startdate',
                        'enddate',
                        'tab'
                    ];

                    if (
                        typeof parts[0] !== 'undefined' &&
                        !ignoreQueryParams.includes(parts[0]) &&
                        typeof parts[1] !== 'undefined'
                        && parts[1] !== ''
                    ) {
                        let filterName = parts[0];
                        let filterValues = parts[1].split('|');

                        if (typeof context.state.selectedFilters[filterName] === 'undefined') {
                            context.commit('setSelectedFilterArray', filterName)
                        }

                        for (let x = 0, len = filterValues.length; x < len; x++) {

                            let id = filterValues[x];
                            if (id.match(/^[0-9]+$/) !== null) {
                                id = parseInt(id);
                            }

                            let filter = {
                                type: filterName,
                                id: id
                            };

                            context.commit('applyFilter', filter)
                        }
                    }
                }

                resolve();
            });
        }
    },

    mutations: {
        setFilter(state, filter) {
            state.filters.push(filter);
        },
        setSearchQuery(state, query) {
            state.searchQuery = query;
        },
        setDates(state, query) {
            let dates = Object.assign({}, state.dates);
            dates[query.key] = query.value;
            state.dates = dates;
        },
        clearFilters(state) {
            state.filters = [];
            state.selectedFilters = {};
            state.selectedFiltersCount = 0;
            state.searchQuery = '';
        },
        resetFilters(state) {
            state.selectedFilters = {};
            state.selectedFiltersCount = 0;
            state.clearedFilters = !state.clearedFilters;

            let page = 1;

            let url = new window.domurl;
            if (typeof url.query.page !== 'undefined') {
                page = parseInt(url.query.page);
            }

            for (let x = 0, len = state.filters.length; x < len; x++) {
                let filter = state.filters[x];

                if (typeof url.query[filter.type] !== 'undefined') {
                    delete url.query[filter.type];
                }
            }

            history.replaceState({path: url.toString()}, '', url.toString());
        },
        setSelectedFilterArray(state, filterName) {
            state.selectedFilters[filterName] = [];
        },
        applyFilter(state, filter) {
            state.selectedFiltersCount++;
            state.selectedFilters[filter.type].push(filter.id);

        },
        removeFilter(state, filter) {
            state.selectedFiltersCount--;
            state.selectedFilters[filter.type].splice(state.selectedFilters[filter.type].indexOf(filter.id), 1);
        },
    }
}
